var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useQuery } from '@apollo/client';
import { useScrollIntoView } from '@bfa/nextjs-common/hooks';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { REFRESHMENTS_URLS } from '../../../../constants';
import useBusinessConfiguration from '../../../../hooks/useBusinessConfiguration';
import useNotificationMessage from '../../../../hooks/useNotificationMessage';
import usePaymentFailureInformation from '../../../../hooks/usePaymentFailureInformation';
import { SUBSCRIBED_LANDING_PAGE_EVENTS as EVENTS } from '../../../../utils/analytics/events';
import GET_SUBSCRIBED_LANDING from './GET_SUBSCRIBED_LANDING';
var useSubscribedLanding = function () {
    var router = useRouter();
    var _a = useBusinessConfiguration(), tenant = _a.tenant, program = _a.program, trackEvent = _a.trackEvent;
    var shouldUserSeePaymentFailurePage = usePaymentFailureInformation().shouldUserSeePaymentFailurePage;
    var _b = __read(useScrollIntoView(), 2), scrollRef = _b[0], onScroll = _b[1];
    var setAddItemMessage = useNotificationMessage().setNotification;
    // Define CMS Content Names
    var subscribedCarouselSectionContentName = "".concat(tenant, "RefreshmentsSubscribedCarouselSection");
    var manageItemsSectionContentName = 'RefreshmentsManageItemsSection';
    var onboardingTourContentName = "".concat(tenant, "RefreshmentsOnboardingTourSection");
    var _c = useQuery(GET_SUBSCRIBED_LANDING, {
        variables: {
            program: program,
            subscribedCarouselSectionContentName: subscribedCarouselSectionContentName,
            manageItemsSectionContentName: manageItemsSectionContentName,
            onboardingTourContentName: onboardingTourContentName,
        },
        errorPolicy: 'ignore',
    }), data = _c.data, loading = _c.loading, error = _c.error;
    var layout = data === null || data === void 0 ? void 0 : data.me.layout;
    /**
     * Shortcut to scroll into scrollRef with same options.
     *
     * @returns An onclick handler.
     */
    var scrollToRef = function () {
        return onScroll({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
        });
    };
    /**
     * Redirect users to Manage Items Page.
     *
     * @returns An onclick handler.
     */
    var redirectToManageItemsPage = function () {
        trackEvent(EVENTS.CLICK_ON_MANAGE_ITEMS);
        return router.push(REFRESHMENTS_URLS.MANAGE_ITEMS);
    };
    useEffect(function () {
        if (!loading && !error) {
            trackEvent(EVENTS.LAND_ON_PAGE);
        }
    }, [error, loading, trackEvent]);
    useEffect(function () {
        if (shouldUserSeePaymentFailurePage) {
            router.push(REFRESHMENTS_URLS.PAYMENT_FAILURE);
        }
    }, [router, shouldUserSeePaymentFailurePage]);
    return {
        loading: loading,
        error: error,
        scrollRef: scrollRef,
        scrollToRef: scrollToRef,
        setAddItemMessage: setAddItemMessage,
        subscribedCarouselSectionContent: layout === null || layout === void 0 ? void 0 : layout.subscribedCarouselSectionContent,
        subscription: data === null || data === void 0 ? void 0 : data.me.subscription,
        onboardingTourContent: layout === null || layout === void 0 ? void 0 : layout.onboardingTourContent,
        shouldUserSeePaymentFailurePage: shouldUserSeePaymentFailurePage,
    };
};
export default useSubscribedLanding;
